module.exports = __webpack_public_path__ + "img/Rick Weber.80f50509.jpg";